import { IPoint2d } from '@/editor/math/IPoint2d';
import { EDirection } from '@/editor/types';

/** 方向键微移的步长 */
export const KEYBOARD_MOVE_STEP = 1;

/**
 * 最后一次按键后多久提交
 *
 * 微移没有 mouseup 这样明确的结束时机，用它把连续按键（含按住不放的重复触发）归为一次移动操作
 */
export const KEYBOARD_MOVE_COMMIT_DELAY = 500;

export function directionToOffset(direction: EDirection): IPoint2d {
  switch (direction) {
    case EDirection.UP:
      return { x: 0, y: KEYBOARD_MOVE_STEP };
    case EDirection.DOWN:
      return { x: 0, y: -KEYBOARD_MOVE_STEP };
    case EDirection.LEFT:
      return { x: -KEYBOARD_MOVE_STEP, y: 0 };
    case EDirection.RIGHT:
      return { x: KEYBOARD_MOVE_STEP, y: 0 };
  }
}
